import { agreeable } from '@dabble/data/agreeable';

export type FileType = File | Blob;

export async function saveFile(file: FileType, maxSize?: number): Promise<string> {
  return agreeable.call('saveFile', file, maxSize);
}
